module.exports = __webpack_public_path__ + "static/img/XAVIER-BAMERT.ad80e7b.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/XAVIER-BAMERT.jpg
// module id = So68
// module chunks = 0